import React from 'react';
import { Navigate } from 'react-router-dom';
import { useClientPortalAuth } from '../context/ClientPortalAuthContext';

interface ClientPortalProtectedRouteProps {
  children: React.ReactNode;
}

const ClientPortalProtectedRoute: React.FC<ClientPortalProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated } = useClientPortalAuth();

  if (!isAuthenticated) {
    return <Navigate to="/client/login" replace />;
  }

  return <>{children}</>;
};

export default ClientPortalProtectedRoute;
